module.exports = __webpack_public_path__ + "img/blocks-image-75-1-img7.2de0071b.jpg";